export const ConstantList = {
  ENTER_KEY: "Enter",
};
export enum SELECT_OPTION {
  SELECT_ACTION = "select-option",
  CLEAR_ACTION = "clear",
  REMOVE_ACTION = "remove-value",
}

export const PERMISSIONS = {
  AUTHORITY: "ADMIN.AUTHORITY",
  DEPARTMENT: "ADMIN.DEPARTMENT",
  ROLE: "ADMIN.ROLE",
  USER: "ADMIN.USER",
  BAO_CAO : "SCYK.BAOCAO",
  SU_CO: "SCYK.SUCO",
  THONG_KE: "SCYK.THONGKE",
  TIEP_NHAN: "SCYK.TIEPNHAN",
  BIEN_BAN_HOP: "SCYK.BIENBANHOP",
  BIEN_BAN_XAC_MINH: "SCYK.BIENBANXACMINH",
  PHAN_TICH: "SCYK.PHANTICH",
  KET_LUAN: "SCYK.KETLUAN",
  MODULE: "MODULE",
  TEST: "SCYK.TEST",
}

export const PERMISSION_ABILITY = {
  VIEW: "VIEW",
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  UPLOAD: "UPLOAD",
  EXPORT: "EXPORT"
}

export const MODULE = {
  HO_SO: "HO_SO",
  TUYEN_DUNG: "TUYEN_DUNG",
  CHAM_CONG: "CHAM_CONG",
  TAI_LIEU: "TAI_LIEU",
  DAO_TAO: "DAO_TAO",
  PHONG_HOP: "PHONG_HOP",
  CONG_VIEC: "CONG_VIEC",
  HE_THONG: "HE_THONG"
}

export const ROLE = {
  USER: "ROLE_USER",
}